<template>
  <div class="dialog-scroll">
    <el-dialog
      class="search-popup"
      :title="query.userGroupFlag? $t('title.popup.system.area.add'):$t('title.popup.system.area.search')"
      :visible.sync="dialogVisible"
      @close="resetForms"
      :before-close="handleDialogClose">
      <!-- 検索エリア START -->
      <el-form
        @submit.native.prevent
        :model="query"
        :rules="rules"
        ref="selectAreaForm">
        <el-row :gutter="16">
          <el-col class="col">
            <el-form-item prop="areaName" class="form-item-size">
              <el-input
                class="input-class"
                maxlength="50"
                size="small"
                :placeholder="$t('label.common.areaNamePlaceHolder')"
                v-model="query.areaName"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="form-group">
              <narrow-down @click="searchArea">
                {{ $t("button.common.narrow") }}
              </narrow-down>
              <cancel-narrow-down @click="clearSearchParams" class="margin-left-8 link-primary">
                {{ $t("button.common.cancelNarrow") }}
              </cancel-narrow-down>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 検索エリア END -->

      <!-- 検索結果 START -->
      <div v-show="isshow" class="search-common">
        <label class="font-size-16 lable-right-16">{{ $t("label.common.count") }}</label>
        <el-select v-model="query.pageSize" @change="changePageSize">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div id="popup-area-search-result" v-show="isshow" class="master-table-type">
        <el-table :data="searchResult.body">
          <el-table-column
            class="font"
            prop="areaName"
            class-name="col-3"
            :label="$t('label.popup.system.area.label.areaName')"/>
          <el-table-column
            class="font"
            prop="areaType"
            class-name="col-3"
            :label="$t('label.popup.system.area.label.areaType')">
            <template slot-scope="scope">
              <span v-if="scope.row.areaType=='01'">
                {{$t('label.popup.system.area.label.areaShare')}}
              </span>
              <span v-if="scope.row.areaType=='02'">
                {{$t('label.popup.system.area.label.tenantLoan')}}
              </span>
              <span v-if="scope.row.areaType=='03'">
                {{$t('label.popup.system.area.label.weekLoan')}}
              </span>
              <span v-if="scope.row.areaType=='04'">
                {{$t('label.popup.system.area.label.other')}}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="location"
            class-name="col-12"
            :label="$t('label.popup.system.area.label.location')">
          </el-table-column>
          <el-table-column class-name="col-2">
            <div slot-scope="scope" class="detail-button with-100">
              <sp-smart-button @click="selectArea(scope.row)" class="detail-button with-100">
                {{ $t("button.common.select") }}
              </sp-smart-button>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <!-- 検索結果 END -->
      <!-- 改ページ START -->
      <pagination
        class="m-top-5"
        v-show="searchResult.body.length > 0"
        :page-size="query.pageSize"
        :page-number="searchResult.pageNumber"
        :totalPage="searchResult.totalPage"
        :totalCount="searchResult.totalCount"
        @on-paging="handlePageChange"
      >
      </pagination>
      <!-- 改ページ END -->
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/common/pagination/Pagination";
import SystemManageApi from "@/api/SystemManageApi";
import errorCodeMsg from "@/utils/error-code-msg"
import popupRuleFactory from "@/rules/rule-popup-area-search";
import narrowDown from "@/components/common/generalButton/NarrowDown";
import cancelNarrowDown from "@/components/common/generalButton/CancelNarrowDown";
import SpSmartButton from "@/components/common/sp-smart-button"
const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_PAGE_NUMBER = 1;
const EVENT_ON_SELECTED = "on-selected";

export default {
  components: {
    Pagination: Pagination,
    narrowDown,
    cancelNarrowDown,
    SpSmartButton,
  },
  name: "AreaSearchPopup",
  props: {
    userGroupFlag: {
      type:Boolean,
      default: null
    },
    tenantIdParam: {
      type: String,
      default: null
    },
    ownerIdParam: {
      type: String,
      default: null
    },
    buildingIdParam: {
      type: String,
      default: null
    },
    floorIdParam: {
      type: Number,
      default: null
    },
    areaNameParam: {
      type: String,
      default: null
    },
    visible: Boolean,
    includeDeleteDataFlag: {
      type: Boolean,
      default: true
    },
    funcCode : {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      isshow: false,
      query: {
        userGroupFlag:false,
        tenantId: this.tenantIdParam,
        ownerId: this.ownerIdParam,
        ownerName: null,
        ownerExId: null,
        buildingId: this.buildingIdParam,
        buildingExId: null,
        buildingName: null,
        floorId: this.floorIdParam,
        floorName: null,
        areaId: null,
        areaName: this.areaNameParam,
        pageSize: DEFAULT_PAGE_SIZE,
        pageNumber: DEFAULT_PAGE_NUMBER,
        funcCode: this.funcCode,
      },
      // 検索結果
      searchResult: {
        totalPage: 0,
        totalCount: 0,
        body: [],
      },
      // 表示状態
      dialogVisible: this.visible,
      rules: popupRuleFactory.popupRules(this),
      isSearching: false,
      options: [
        {
          value: 10,
          label: "",
        },
        {
          value: 20,
          label: "",
        },
        {
          value: 50,
          label: "",
        },
      ],
    };
  },
  watch: {
    visible: function (value) {
      this.dialogVisible = value;
      this.query.ownerId = this.ownerIdParam;
      this.query.buildingId = this.buildingIdParam;
      this.query.floorId = this.floorIdParam;
      this.query.areaName = this.areaNameParam;
      this.query.tenantId = this.tenantIdParam;
      this.query.userGroupFlag = this.userGroupFlag
    },
    // ownerIdParam: function (value) {
    //   this.query.ownerId = value;
    // },
    // buildingIdParam: function (value) {
    //   this.query.buildingId = value;
    // },
    // floorIdParam: function (value) {
    //   this.query.floorId = value;
    // },
    // areaNameParam: function (value) {
    //   this.query.areaName = value;
    // }
  },
  methods: {
    resetForms() {
      this.$refs['selectAreaForm'].resetFields()
    },
    changePageSize(){
      this.query.pageNumber = 1
      this.searchArea()
    },

    searchArea: function () {
      // エリア情報検索：管理API
      this.$refs["selectAreaForm"].validate((valid) => {
        if (valid) {
          if (!this.isSearching) {
            this.isSearching = true;
            this.showTableLoadingAnim();
            if(this.includeDeleteDataFlag == null) {
              this.includeDeleteDataFlag = true
            }
            SystemManageApi.searchArea({
              tenantId: this.query.tenantId,
              ownerId: this.query.ownerId,
              ownerExId: this.query.ownerExId,
              ownerName: this.query.ownerName,
              buildingId: this.query.buildingId,
              buildingExId: this.query.buildingExId,
              buildingName: this.query.buildingName,
              floorName: this.query.floorName,
              floorId: this.query.floorId,
              areaId: this.query.areaId,
              areaName: this.query.areaName,
              includeDeleteDataFlag: this.includeDeleteDataFlag,
              pageSize: this.query.pageSize,
              pageNumber: this.query.pageNumber,
              funcCode: this.funcCode
            })
            .catch((error) => {
              errorCodeMsg(error, this)
            })
            .then((resp) => {
              this.searchResult.pageNumber = resp.data.body.pageNumber;
              this.searchResult.totalPage = resp.data.body.totalPage;
              this.searchResult.totalCount = resp.data.body.totalCount;
              this.query.pageSize = resp.data.body.pageSize;
              this.searchResult.body = [];
              for (let body of resp.data.body.body) {
                this.searchResult.body.push({
                  ownerId: body.ownerId,
                  ownerExId: body.ownerExId,
                  ownerName: body.ownerName,
                  buildingId: body.buildingId,
                  buildingExId: body.buildingExId,
                  buildingName: body.buildingName,
                  floorId: body.floorId,
                  floorName: body.floorName,
                  areaId: body.areaId,
                  areaType: body.areaType,
                  areaName: body.areaName,
                  location:
                    body.ownerName +
                    "　" +
                    body.buildingName +
                    "　" +
                    body.floorName,
                });
              }
            }).finally(() => {
              this.isSearching = false;
              this.hideTableLoadingAnim();
            });
          }
          this.isshow = true;
        } else {
          return false;
        }
      });
    },
    //show anim
    showTableLoadingAnim() {
      if (this.tableLoadingAnim == null) {
        this.tableLoadingAnim = this.$loading({
          target: "#popup-area-search-result",
          background: "#ebebe6"
        });
      }
    },
    //hide anim
    hideTableLoadingAnim() {
      if (this.tableLoadingAnim != null) {
        this.tableLoadingAnim.close();
        this.tableLoadingAnim = null;
      }
    },
    // エリア選択
    selectArea(area) {
      this.dialogVisible = false;
      this.$emit(EVENT_ON_SELECTED, area);
      this.$emit("update:visible", false);
      this.clearSearchParams();
      this.isshow = false;
    },

    // 検索条件クリア
    clearSearchParams: function () {
      this.query.areaName = null;
      this.query.pageSize = DEFAULT_PAGE_SIZE;
      this.query.pageNumber = DEFAULT_PAGE_NUMBER;
      this.searchResult.body = [];
      //this.$refs["selectAreaForm"].resetFields();
      this.isshow = false;
    },
    // Dialog閉じる
    handleDialogClose: function () {
      this.dialogVisible = false;
      this.$emit("update:visible", false);
      this.clearSearchParams();
      this.isshow = false;
    },
    // 改ページ
    handlePageChange: function (paging) {
      this.query.pageSize = paging.pageSize;
      this.query.pageNumber = paging.pageNumber;
      this.searchArea();
    },
  },
  mounted() {
    this.options[0].label = "10" + this.$t("label.common.case");
    this.options[1].label = "20" + this.$t("label.common.case");
    this.options[2].label = "50" + this.$t("label.common.case");
  },
};
</script>

<style lang="scss" scoped>
.form-item-size{
  ::v-deep .el-form-item__error{
    width: 200px;
  }
}
.title {
  height: 60px;
  font-size: 24px;
  font-weight: bold;
  // color: #2699fb;
}
.el-select {
  line-height: 42px;
  width: 100px;
  font-size: 12px;
  height: 18px;
  border-radius: 8px;
  // overflow: hidden;
  color: #fff;

  ::v-deep.el-input__inner {
    border: none;
    // line-height: 24px;
    background-color: #f2f2ed;
    color: #525250;
    // font-size: 15px !important;
    // padding-left: 20px;
    box-shadow: -2px -2px 5px #fff,
      5px 5px 8px #e6e6e1;
  }
  ::placeholder {
    color: #525250;
  }
}

.search-popup {
  ::v-deep  .el-dialog {
    width: 1024px;
    height: 700px;
    background-color: #f2f2ed;
    border-radius: 3px !important;
    ::v-deep .el-dialog__header {
      height: 50px;
      ::v-deep .el-dialog__body {
        padding: 0px 24px 0px 19px;
      }
    }
  }
}

.left-input {
  margin-top: 13px;
  width: 200px;
}
.right-input {
  margin-top: 13px;
  margin-left: 16px;
  width: 200px;
  height: 22px;
}
.col {
  display: flex;
  flex-direction: row;
}
::v-deep .el-form-item__content {
  line-height: 22px;
}
.label {
  // color: #2699fb;
  font-size: 12px;
}

.btn-operate {
  margin: 0 5px 0 0;
}
::v-deep .detail-button{
  button {
    width: 100%;
  }
  .my-button{
    width: 134px;
  }
}

::v-deep .detail-button .my-button {
  margin-left: 5px;
}
::v-deep .detail-button .my-button {
  width: 100%;
  height: 40px;
  line-height: 0;
}

// add by mxq
.input_item {
  margin-right: 20px;
  ::v-deep.el-input .el-input__inner {
    width: 296px;
    height: 44px !important;
    border-radius: 8px !important;
    background: #f2f2ed;
    border: none;
    box-shadow: -2px -2px 5px #ffffff inset, -2px -2px 5px #ffffff inset,
      4px 5px 5px #e6e6e1 inset, 4px 5px 5px #e6e6e1 inset;
  }
}

::v-deep.el-icon-close {
  color: rgb(0, 0, 0);
}
.button_title {
  font-size: 12px;
  position: relative;
  bottom: 6px;
}
.search-common {
  display: block;
  //float: right;
  text-align: right;
  margin-top: 36px;
  margin-bottom: 20px;
}
::v-deep .input-class {
  .el-input__inner {
    width: 324px;
    height: 44px !important;
    border-radius: 8px !important;
    background: #f2f2ed;
    border: none;
    box-shadow: -2px -2px 5px #ffffff inset, -2px -2px 5px #ffffff inset,
      4px 5px 5px #e6e6e1 inset, 4px 5px 5px #e6e6e1 inset;
  }
}

::v-deep .el-dialog .el-dialog__header {
  height: 60px !important;
}
</style>
